import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { CourseStationContext } from "@ryde/redux";

import { StationHeaderRightIconsWrapperStyled } from "./stations.course.styled";

export const StationRowButtonsCourse: FC = () => {
  const { removeCourseStation } = useContext(CourseStationContext);
  const removeStationHandler = useEvent(async () => removeCourseStation?.());
  const { t } = useTranslation();

  return (
    <StationHeaderRightIconsWrapperStyled>
      <FramerTooltip content={t("course.ARCHIVE_STATION")}>
        <SVG_MUI.Trash2SVG
          className="pointer trash"
          onClick={removeStationHandler}
        />
      </FramerTooltip>
    </StationHeaderRightIconsWrapperStyled>
  );
};
